import React from 'react';
import CreatePerquisitesForm from './CreatePerquisitesForm';

const CreatePerquisitesView = () => {
  return <CreatePerquisitesForm />;
};

export default CreatePerquisitesView; 